import {
  getHaklaiLogicalPropertyPartKey,
  mergeHaklaiPartKeyedDepreciationProfile
} from "./haklaiFlowHelpers";
import {
  getHaklaiPartDepreciationMode,
  hasHaklaiSelectablePurchaseDepreciationProfile,
  HAKLAI_PROPERTY_DEPRECIATION_MODE
} from "./haklaiDepreciationHelpers";

const areFlatObjectsEqual = (first = {}, second = {}) => {
  const firstKeys = Object.keys(first || {});
  const secondKeys = Object.keys(second || {});
  if (firstKeys.length !== secondKeys.length) return false;
  return firstKeys.every((key) => first[key] === second[key]);
};

export const normalizeHaklaiPurchaseDepreciationStateForLogicalParts = (
  mainCalc = {},
  logicalPropertyPartsData = {}
) => {
  const propertyPartsData = mainCalc.propertyPartsData || {};
  const purchaseDepreciationByPart = Object.entries(mainCalc.purchaseDepreciationByPart || {})
    .reduce((acc, [partKey, depreciation]) => {
      const logicalPartKey = getHaklaiLogicalPropertyPartKey({
        partKey,
        propertyPartsData,
        logicalPropertyPartsData
      });
      const part = logicalPropertyPartsData[logicalPartKey];
      if (getHaklaiPartDepreciationMode(part) === HAKLAI_PROPERTY_DEPRECIATION_MODE.MANUAL_FORM_11) {
        acc[logicalPartKey] = mergeHaklaiPartKeyedDepreciationProfile(acc[logicalPartKey], depreciation);
      }
      return acc;
    }, {});

  const purchaseDepreciationSelectionByPart = Object.entries(mainCalc.purchaseDepreciationSelectionByPart || {})
    .reduce((acc, [partKey, isSelected]) => {
      const logicalPartKey = getHaklaiLogicalPropertyPartKey({
        partKey,
        propertyPartsData,
        logicalPropertyPartsData
      });
      const part = logicalPropertyPartsData[logicalPartKey];
      const hasPurchaseProfile = hasHaklaiSelectablePurchaseDepreciationProfile({
        partKey: logicalPartKey,
        part,
        residentialRentalByPart: mainCalc.residentialRentalByPart || {},
        purchaseDepreciationByPart
      });
      if (isSelected === true && part && hasPurchaseProfile) {
        acc[logicalPartKey] = true;
      }
      return acc;
    }, {});

  return {
    changed:
      !areFlatObjectsEqual(mainCalc.purchaseDepreciationByPart || {}, purchaseDepreciationByPart)
      || !areFlatObjectsEqual(mainCalc.purchaseDepreciationSelectionByPart || {}, purchaseDepreciationSelectionByPart),
    purchaseDepreciationByPart,
    purchaseDepreciationSelectionByPart
  };
};
